(function () {
  function startVideos() {
    document.querySelectorAll("[data-promo-video]").forEach(function (el) {
      var delay = parseInt(
        el.getAttribute("data-promo-video-delay") || "0",
        10,
      );
      setTimeout(function () {
        if (el.play) {
          el.play().catch(function () {});
        }
      }, isNaN(delay) ? 0 : delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startVideos);
  } else {
    startVideos();
  }
})();
